import { DestroyRef, inject, Injectable } from '@angular/core';
import { AppService } from '@nk/access-block';
import { CompanyEventVoteEntity, AppFeedbackEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';
import { HttpParams } from '@angular/common/http';
import { ApplicationApiClient } from '@nk/api-client-lib';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

type FeedbackTypeKey = 'general_feedback' | 'survey';

@Injectable()
export class FeedbackService {
  public identity: AppIdentityCompositeEntity;
  private _destroy = inject(DestroyRef);

  constructor(
    private _api: ApplicationApiClient,
    private _appService: AppService,
  ) {
    this._appService.identityDataCache
      .get()
      .pipe(takeUntilDestroyed(this._destroy))
      .subscribe((identity) => {
        this.identity = identity;
      });
  }

  public submitCompanyEventVote(companyEventUuid: string, vote: number): Observable<CompanyEventVoteEntity> {
    const payload = {
      company_event_uuid: companyEventUuid,
      app_membership_uuid: this.identity.app_membership.uuid,
      vote: vote,
    };
    return this._api.post<CompanyEventVoteEntity>('company-event-vote', payload);
  }

  public submitFeedback(
    message: string | null,
    feedbackTypeKey?: FeedbackTypeKey,
    appSurveyKey?: string,
    appSurveyUuid?: string,
    question?: string,
    rating?: number | null,
    optOut?: boolean,
  ): Observable<AppFeedbackEntity> {
    let httpParam = new HttpParams();
    if (optOut) {
      httpParam = httpParam.append('opt_out', true);
    }

    const payload: Partial<AppFeedbackEntity> = {
      app_membership_uuid: this.identity.app_membership.uuid,
      message: message,
      feedback_type_key: feedbackTypeKey,
      app_survey_key: appSurveyKey,
      app_survey_uuid: appSurveyUuid,
      question: question,
      rating: rating,
    };

    return this._api.post<AppFeedbackEntity>('app-feedback', payload, { params: httpParam }, []);
  }
}
